import { EventFeedEvent } from '@toggle/toggle';

const now = new Date();
const oneHourAgo = new Date(now.getTime() - 1 * 60 * 60 * 1000);
const threeHoursAgo = new Date(now.getTime() - 3 * 60 * 60 * 1000);
const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
const twoDaysAgo = new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000);
const threeDaysAgo = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000);
const fourDaysAgo = new Date(now.getTime() - 4 * 24 * 60 * 60 * 1000);

export const mockFeedEvents: EventFeedEvent[] = [
  // Market Summary - Unread (Pre-market)
  {
    id: 'market-summary-1',
    type: 'market_summary',
    entity: 'market',
    created_at: oneHourAgo.toISOString(),
    title: 'Pre-Market Summary',
    summary:
      'Markets are opening higher today following positive earnings reports from major tech companies. Investors are optimistic about the upcoming trading session.',
    metadata: {
      market_hours: 'pre_market',
      articles: [],
      questions: [],
    },
    read: false,
    relevance: {
      tier: 1,
      connections: null,
    },
  },
  // Catalyst - Unread
  {
    id: 'catalyst-1',
    type: 'catalyst',
    entity: 'aapl_nasd',
    created_at: threeHoursAgo.toISOString(),
    title: 'Apple: New Product Launch Announcement',
    summary: 'Apple announces new product lineup for 2025.',
    metadata: {
      category: 'company',
      sub_category: 'financial_operational_updates',
      action_type: 'update',
    },
    read: false,
    relevance: {
      tier: 1,
      connections: [
        {
          entity: 'aapl_nasd',
          watchlist_ids: [
            '523d919c-b251-4456-931f-55429a9ef661',
            'dac1779f-28ee-4a65-82eb-b31abf67e6fd',
            '50cf9c47-42c2-41b6-b39c-aad6d35b6d8a',
          ],
        },
      ],
    },
  },
  // Scenario - Unread (Bearish)
  {
    id: 'scenario-1',
    type: 'scenario',
    entity: 'aapl_nasd',
    created_at: yesterday.toISOString(),
    title: "Apple's RSI technical indicator saw a large increase",
    summary: 'Technical analysis suggests potential downside.',
    metadata: {
      insight_id: 'insight-aapl-rsi',
      median: -0.0607,
      horizon: '6M',
      stars: 5,
      episode_count: 5,
    },
    read: false,
    relevance: {
      tier: 1,
      connections: [{ entity: 'aapl_nasd', watchlist_ids: ['watchlist-1'] }],
    },
  },
  // Market Summary - Read (Closed market)
  {
    id: 'market-summary-2',
    type: 'market_summary',
    entity: 'market',
    created_at: yesterday.toISOString(),
    title: 'Market Close Summary',
    summary:
      'Markets closed lower yesterday as investors weighed concerns about inflation and interest rates. Technology stocks led the decline.',
    metadata: {
      market_hours: 'closed_market',
      articles: [],
      questions: [],
    },
    read: true,
    relevance: {
      tier: 1,
      connections: null,
    },
  },
  // Catalyst - Read
  {
    id: 'catalyst-2',
    type: 'catalyst',
    entity: 'msft_nasd',
    created_at: twoDaysAgo.toISOString(),
    title: 'Microsoft: Azure Revenue Growth Accelerates',
    summary: 'Microsoft cloud services see strong quarter.',
    metadata: {
      category: 'company',
      sub_category: 'corporate_actions_strategic_announcements',
      action_type: 'partnership',
    },
    read: true,
    relevance: {
      tier: 1,
      connections: [{ entity: 'msft_nasd', watchlist_ids: ['watchlist-1'] }],
    },
  },
  // Scenario - Read (Bullish, Tier 2)
  {
    id: 'scenario-2',
    type: 'scenario',
    entity: 'msft_nasd',
    created_at: twoDaysAgo.toISOString(),
    title: "Microsoft's momentum indicator signals bullish trend",
    summary: 'Technical patterns suggest potential upside.',
    metadata: {
      insight_id: 'insight-msft-momentum',
      median: 0.2345,
      horizon: '3M',
      stars: 4,
      episode_count: 8,
    },
    read: true,
    relevance: {
      tier: 2,
      connections: [
        {
          entity: 'msft_nasd',
          watchlist_ids: [
            '523d919c-b251-4456-931f-55429a9ef661',
            'dac1779f-28ee-4a65-82eb-b31abf67e6fd',
            '50cf9c47-42c2-41b6-b39c-aad6d35b6d8a',
          ],
        },
        { entity: 'googl_nasd', watchlist_ids: ['watchlist-2'] },
        { entity: 'aapl_nasd', watchlist_ids: ['watchlist-3'] },
      ],
    },
  },
  // Earnings Preview - Unread
  {
    id: 'earnings-preview-1',
    type: 'earnings',
    entity: 'crm_nyse',
    created_at: threeDaysAgo.toISOString(),
    title:
      'Salesforce Q3: High Expectations, AI Focus, and Valuation Test Ahead',
    summary: 'Analysts expect strong cloud revenue growth.',
    metadata: {
      earnings_type: 'preview',
      earnings_id: '5a5656cc-f40b-463f-b052-47a4b762d8db',
      eps_estimate: 2.44,
      currency: 'USD',
      reporting_date: new Date(
        now.getTime() + 7 * 24 * 60 * 60 * 1000
      ).toISOString(),
    },
    read: false,
    relevance: {
      tier: 1,
      connections: [{ entity: 'crm_nyse', watchlist_ids: ['watchlist-1'] }],
    },
  },
  // Earnings Recap - Unread (Beat, Tier 2)
  {
    id: 'earnings-recap-1',
    type: 'earnings',
    entity: 'crm_nyse',
    created_at: threeDaysAgo.toISOString(),
    title:
      'Salesforce Q3-2025 Earnings: EPS and Revenue Beat Expectations Amid Strong Cloud Growth',
    summary: 'Salesforce exceeded analyst expectations on all metrics.',
    metadata: {
      earnings_type: 'recap',
      earnings_id: '5a5656cc-f40b-463f-b052-47a4b762d8db',
      eps_actual: 2.56,
      eps_surprise_percentage: 4.9,
      currency: 'USD',
    },
    read: false,
    relevance: {
      tier: 2,
      connections: [
        { entity: 'crm_nyse', watchlist_ids: ['watchlist-1'] },
        { entity: 'orcl_nyse', watchlist_ids: ['watchlist-2'] },
      ],
    },
  },
  // Catalyst - Unread (NVIDIA)
  {
    id: 'catalyst-3',
    type: 'catalyst',
    entity: 'nvda_nasd',
    created_at: threeDaysAgo.toISOString(),
    title: 'NVIDIA Unveils Next-Gen GPU Architecture',
    summary: 'NVIDIA announces new Blackwell architecture for AI workloads.',
    metadata: {
      category: 'company',
      sub_category: 'financial_operational_updates',
      action_type: 'product_launch',
    },
    read: false,
    relevance: {
      tier: 1,
      connections: [{ entity: 'nvda_nasd', watchlist_ids: ['watchlist-1'] }],
    },
  },
  // Earnings Preview - Read
  {
    id: 'earnings-preview-2',
    type: 'earnings',
    entity: 'amzn_nasd',
    created_at: fourDaysAgo.toISOString(),
    title: 'Amazon Q4: AWS Growth and Holiday Season Sales in Focus',
    summary: 'Investors watch for AWS margins and retail performance.',
    metadata: {
      earnings_type: 'preview',
      earnings_id: 'earnings-amzn-q4',
      eps_estimate: 1.48,
      currency: 'USD',
      reporting_date: new Date(
        now.getTime() + 14 * 24 * 60 * 60 * 1000
      ).toISOString(),
    },
    read: true,
    relevance: {
      tier: 1,
      connections: [{ entity: 'amzn_nasd', watchlist_ids: ['watchlist-1'] }],
    },
  },
  // Earnings Recap - Read (Miss)
  {
    id: 'earnings-recap-2',
    type: 'earnings',
    entity: 'meta_nasd',
    created_at: fourDaysAgo.toISOString(),
    title:
      'Meta Q3-2025 Earnings: Strong Ad Revenue Growth Offset by Reality Labs Losses',
    summary: 'Meta beats on revenue but misses EPS expectations.',
    metadata: {
      earnings_type: 'recap',
      earnings_id: 'earnings-meta-q3',
      eps_actual: 4.12,
      eps_surprise_percentage: -2.8,
      currency: 'USD',
    },
    read: true,
    relevance: {
      tier: 1,
      connections: [{ entity: 'meta_nasd', watchlist_ids: ['watchlist-1'] }],
    },
  },
  // Catalyst - Read (Tesla)
  {
    id: 'catalyst-4',
    type: 'catalyst',
    entity: 'tsla_nasd',
    created_at: fourDaysAgo.toISOString(),
    title: 'Tesla Expands Supercharger Network in Europe',
    summary: 'Tesla announces major expansion of charging infrastructure.',
    metadata: {
      category: 'company',
      sub_category: 'corporate_actions_strategic_announcements',
      action_type: 'expansion',
    },
    read: true,
    relevance: {
      tier: 1,
      connections: [{ entity: 'tsla_nasd', watchlist_ids: ['watchlist-1'] }],
    },
  },
];
